export default "__VITE_ASSET__DLY0x_YT__"